import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { HelperPlus2Service } from '~/core/services/helper-plus2.service';
import { ResizeListenerService } from '~/core/services/resize-listener.service';

@Component({
  selector: 'app-menu-toggle-button',
  templateUrl: './menu-toggle-button.component.html',
  styleUrls: ['./menu-toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconButton, MatIcon],
})
export class MenuToggleButtonComponent {
  private readonly _helper = inject(HelperPlus2Service);
  private readonly _resizeListener = inject(ResizeListenerService);

  readonly isOpen = computed(() => !this._helper.leftMenuCollapsing());
  readonly hidden = computed(() => this._helper.hideMenu());
  readonly _isDesktop = computed(() => !this._resizeListener.isMobile() && !JSON.parse(localStorage.getItem('MOBILE_VERSION') || 'false'));

  readonly toggled = output<void>();

  toggle(): void {
    this._helper.leftMenuCollapsing.set(!this._helper.leftMenuCollapsing());
    this.toggled.emit();
  }
}
